'use client'

import { IBaseUser } from '@/api/interfaces/IBaseUser'
import { IImage } from '@/api/interfaces/IImage'
import { IBaseUserUnion } from '@/util/avatar'
import { getImagePointColorGradient } from '@/util/color'
import classNames from 'classnames'
import Image, { StaticImageData } from 'next/image'
import { useLayoutEffect, useMemo, useRef, useState } from 'react'

type Props = {
  size: number
  image?: IImage | string | IBaseUserUnion | StaticImageData | null
  className?: string
  onClick?: () => void
  onKeyColor?: (color: string) => void
}

const defaultImages = [
  '/images/default_profile_2.png',
  '/images/default_profile_3.png',
  '/images/default_profile_4.png',
  '/images/default_profile_5.png',
  '/images/default_profile_1.png',
]

function hashStringToNumber(inputString: string): number {
  if (!inputString) {
    return 0
  }

  let hash = 0
  for (let i = 0; i < inputString.length; i++) {
    const charCode = inputString.charCodeAt(i)
    hash += charCode
  }

  return hash % 5
}

export const Avatar = ({
  size,
  image,
  className,
  onClick,
  onKeyColor,
}: Props) => {
  const [error, setError] = useState(false)

  const imageRef = useRef<HTMLImageElement>(null)

  const source = useMemo(() => {
    if (image !== undefined && image !== null && typeof image === 'string') {
      return image
    }

    if (!image || error) {
      return '/images/default_profile_5.png'
    }

    if (image && 'src' in image) {
      return image
    }

    // let user

    // if (error) {
    //   user = image as IBaseUser
    //   return defaultImages[hashStringToNumber(user.hash)]
    // }

    if (Object.getOwnPropertyNames(image).includes('username')) {
      const user = image as IBaseUser

      if (user.profileImage) {
        return user.profileImage.thumbnail
      } else {
        return defaultImages[hashStringToNumber(user.hash)]
      }
    }

    const baseImage = image as IImage

    return baseImage.thumbnail
  }, [error, image])

  useLayoutEffect(() => {
    if (onKeyColor) {
      imageRef.current!.onload = () => {
        onKeyColor(getImagePointColorGradient(imageRef.current))
      }
    }
  }, [onKeyColor])

  return (
    <div
      onClick={onClick}
      className={classNames('rounded-full overflow-hidden shrink-0', className)}
      style={{
        width: size,
        height: size,
      }}
    >
      <Image
        ref={imageRef}
        src={
          source || defaultImages[hashStringToNumber((image as IBaseUser).hash)]
        }
        alt="프로필 이미지"
        width={size}
        height={size}
        onError={(e) => setError(!!e)}
        draggable="false"
        style={{
          width: size,
          height: size,
          objectFit: 'contain',
        }}
      />
    </div>
  )
}
